import Button from "components/Button/Button";
import Swimlane, { SwimlaneItem } from "components/Swimlane/Swimlane";

type MetaDocErrorScreenProps = {
  title?: string;
  message: string;
  detail?: string;
  actionLabel?: string;
  onAction?: () => void;
};

const MetaDocErrorScreen = ({
  title = "Processing Failed",
  message,
  detail,
  actionLabel = "Try Again",
  onAction,
}: MetaDocErrorScreenProps) => {
  return (
    <Swimlane>
      <SwimlaneItem heading="Meta Document">
        <div className="metadoc-error">
          <span className="material-icons metadoc-error-icon">
            error_outline
          </span>
          <p className="metadoc-error-message">{message || title}</p>
          {detail && <p className="metadoc-error-detail">{detail}</p>}
          {onAction && (
            <Button className="metadoc-select-button" onClick={onAction}>
              {actionLabel}
            </Button>
          )}
        </div>
      </SwimlaneItem>
    </Swimlane>
  );
};

export default MetaDocErrorScreen;
